<template>
  <div class="page-head">
    <div>
      <h1>{{ title }}</h1>
      <div v-if="sub" class="sub">{{ sub }}</div>
    </div>
    <div v-if="$slots.actions" class="actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHead',
  props: {
    title: { type: String, required: true },
    sub: { type: String, default: '' }
  }
}
</script>
